import { Component } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import * as fromRoot from '../../../common/reducers';
import * as auth from '../../../common/actions/authentication';
import { Store } from '@ngrx/store';
import * as fromUtility from 'app/common/services/Utility.service';
import { EvsAuthenticationService } from '../../../common/services/EvsAuthentication.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { TranslateService } from '@ngx-translate/core';

declare var $: any;

// import { AuthGuard } from 'app/common/services/Auth.guard';

/**
 * This class represents the lazy loaded HomeComponent.
 */

@Component({
  selector: 'sd-login',
  templateUrl: 'login-v3.component.html',
  styleUrls: ['./login-v3.css'],
  providers: [EvsAuthenticationService],
})
export class LoginComponent {
  datas: any = [];
  loginForm: FormGroup;
  model: any = {};
  modalRef: BsModalRef;
  currentLang: string = localStorage.getItem('lang') || 'vi';
  // isVisible: boolean = false
  // @ViewChild("bannerModal") public bannerModal: TemplateRef<any>;

  constructor(
    private store: Store<fromRoot.State>,
    private authEvs: EvsAuthenticationService,
    private router: Router,
    private modalService: BsModalService,
    private translate: TranslateService
  ) {
    this.translate.use(this.currentLang);
    let body = document.getElementsByTagName('body')[0];
    body.classList.add('animsition'); //add the class
    // body.classList.add("page-login-v2");   //add the class
    // body.classList.add("page-login-v3");   //add the class
    body.classList.add('layout-full'); //add the class
    // body.classList.add("page-dark");   //add the class
  }

  authenticate(provider: string) {
    this.store.dispatch(new auth.LoginAction({ provider: provider }));
  }

  // tslint:disable-next-line:use-life-cycle-interface
  ngOnInit() {
    const inputs = $('#otp').find('input')
    for (let i = 0; i < inputs.length; i++) {
      inputs[i].addEventListener('keydown', function (event) {
        if (event.key === 'Backspace') {
          inputs[i].value = '';
          if (i !== 0) {
            inputs[i - 1].focus();
          }
        } else {
          if (i === inputs.length - 1 && inputs[i].value !== '') {
            return true;
          } else if (event.keyCode > 47 && event.keyCode < 58 || (event.keyCode >= 96 && event.keyCode <= 105) || event.keyCode === 39) {
            inputs[i].value = event.key;
            if (i !== inputs.length - 1) {
              inputs[i + 1].focus();
            }
            event.preventDefault();
          } else if (event.keyCode > 64 && event.keyCode < 91) {
            inputs[i].value = String.fromCharCode(event.keyCode);
            if (i !== inputs.length - 1) {
              inputs[i + 1].focus();
            }
            event.preventDefault();
          }
        }
      });
    }

    // $('.digit-group').find('input').each(function () {
    //   $(this).attr('maxlength', 1);
    //   $(this).on('keyup', function (e) {
    //     // tslint:disable-next-line:prefer-const
    //     const parent = $($(this).parent());
    //     if (e.keyCode === 8 || e.keyCode === 37) {
    //       const prev = parent.find('input#' + $(this).data('previous'));
    //       if (prev.length) {
    //         $(prev).select();
    //       }
    //       // tslint:disable-next-line:max-line-length
    //     } else if ((e.keyCode >= 48 && e.keyCode <= 57) || (e.keyCode >= 65 && e.keyCode <= 90) || (e.keyCode >= 96 && e.keyCode <= 105) || e.keyCode === 39) {
    //       const next = parent.find('input#' + $(this).data('next'));
    //       if (next.length) {
    //         $(next).select();
    //       } else {
    //         if (parent.data('autosubmit')) {
    //           parent.submit();
    //         }
    //       }
    //     }
    //   });
    // });
    // console.log('$(\'.digit-group\').find(\'input\')', $('.digit-group').find('input'))
    // if (sessionStorage.getItem("seenBanner") !== "seen") {
    //   sessionStorage.setItem("seenBanner", "seen");
    //   this.isVisible = true
    // } else {
    //   this.isVisible = false
    // }
    if (
      !localStorage.getItem('Access-Token') ||
      !localStorage.getItem('Access-Token-Icheck')
    ) {
      const lang = localStorage.getItem('lang');
      localStorage.clear();
      if (lang) {
        localStorage.setItem('lang', lang);
      }
      this.router.navigate(['/login']);
      console.log('vao 1')
    } else {
      this.router.navigate(['/']);
      console.log('vao 2')
    }
    // this.store.select("authentication").subscribe((state: any) => {
    //   this.token_link = state.token_link;
    // });
    // this.local_token_link = this.local_token_link || localStorage.getItem("token_link");
  }

  changeLanguage(lang: string) {
    this.currentLang = lang;
    this.translate.use(lang);
    localStorage.setItem('lang', lang);
  }

  OTPInput() {

  }

  OpenLink(route?: string, id?: string) {
    var Link = fromUtility.UtilityService.route(route, id);
    return Link;
  }

  // handleCancel() {
  //   this.isVisible = false
  // }
  onSubmit(data) {
    let mUser = {
      username: data.username,
      password: data.password,
      ttl_in_second: 86400 * 3,
    };
    this.store.dispatch(new auth.LoginAction(mUser));
  }

  test(data) {
    console.log('data', data)
    // @ts-ignore
    this.router.navigate(['/reset-password-login'], { queryParams: { usernamePre: data.username, passwordPre: data.password } });
  }

  // navToLinkAccount() {
  //   this.router.navigate(["/link-account"]);
  //   this.modalRef.hide();
  // }
}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/auth/login.component.ts